<script lang="tsx" setup>
import { computed } from "vue"

import { useScrollOpacityTarget } from "@/composables/use-scroll-opacity-target"

import InfoGrid from "@/components/Layout/InfoGrid.vue"

const { fadeHeader = false } = defineProps<{
  fadeHeader?: boolean
}>()

const { progress, addTargetListener } = useScrollOpacityTarget()

if (fadeHeader) {
  addTargetListener("student-header", el => window.scrollY / el.offsetHeight)
}

const headerOpacity = computed(() => (fadeHeader ? progress.value : 1))
</script>

<template>
  <InfoGrid>
    <template v-if="$slots.header" #header>
      <div
        class="body-text pr-8"
        :style="{ '--scroll-opacity': headerOpacity }"
      >
        <slot name="header" />
      </div>
    </template>

    <template v-if="$slots.meta" #meta>
      <slot name="meta" />
    </template>

    <template v-if="$slots.body" #body>
      <slot name="body" />
    </template>
  </InfoGrid>
</template>
